import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, TextField, Box } from '@mui/material';
import { getDeviceThresholds } from "../API/deviceThresholds";

const ElectricityConfigSection = ({ electricityDevices, onThresholdsChange }) => {
  const [deviceValues, setDeviceValues] = useState({});
  const [loading, setLoading] = useState(true);

  const loadThresholds = useCallback(async () => {
    if (!electricityDevices || electricityDevices.length === 0) return;

    setLoading(true);
    const newValues = {};

    try {
      for (const device of electricityDevices) {
        try {
          const response = await getDeviceThresholds(device.dev_eui);
          const thresholds = response.thresholds || [];

          // Valeurs par défaut si pas de seuils existants
          let yellowValue = 8;
          let redValue = 10;

          // Récupérer seuils existants
          const yellowThreshold = thresholds.find(t => t.threshold_type === 'yellow');
          const redThreshold = thresholds.find(t => t.threshold_type === 'red');

          if (yellowThreshold) yellowValue = yellowThreshold.threshold_value;
          if (redThreshold) redValue = redThreshold.threshold_value;

          newValues[device.dev_eui] = {
            yellow: yellowValue,
            red: redValue
          };
        } catch (error) {
          // Pas de seuils existants, utilisation valeurs par défaut
          newValues[device.dev_eui] = {
            yellow: 8,
            red: 10
          };
        }
      }

      setDeviceValues(newValues);
      onThresholdsChange?.(newValues);
    } catch (error) {
      // Erreur silencieuse
    } finally {
      setLoading(false);
    }
  }, [electricityDevices, onThresholdsChange]);

  // Chargement automatique des seuils existants
  useEffect(() => {
    loadThresholds();
  }, [loadThresholds]);

  // Gestion des modifications
  const handleValueChange = (deviceEui, type, value) => {
    const newValues = {
      ...deviceValues,
      [deviceEui]: {
        ...deviceValues[deviceEui],
        [type]: parseFloat(value) || 0
      }
    };
    setDeviceValues(newValues);
    onThresholdsChange?.(newValues);
  };

  if (!electricityDevices || electricityDevices.length === 0) return null;
  if (loading) return <div>Chargement des seuils électricité...</div>;

  return (
    <Card sx={{ mt: 3 }}>
      <CardHeader 
        title="Configuration Seuils Électricité" 
        subheader="Modifiez les seuils puis utilisez le bouton 'METTRE À JOUR' en bas de page pour sauvegarder."
      />
      <CardContent>
        {electricityDevices.map((device) => (
          <Box key={device.dev_eui} sx={{ mb: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
            <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              {device.name} ({device.brand_name})
            </div>
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <TextField 
                label="Seuil Jaune (kWh)" 
                type="number" 
                value={deviceValues[device.dev_eui]?.yellow || 8}
                onChange={(e) => handleValueChange(device.dev_eui, 'yellow', e.target.value)}
                size="small"
              />
              <TextField 
                label="Seuil Rouge (kWh)" 
                type="number" 
                value={deviceValues[device.dev_eui]?.red || 10}
                onChange={(e) => handleValueChange(device.dev_eui, 'red', e.target.value)}
                size="small"
              />
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default ElectricityConfigSection;
